export default __webpack_public_path__ + "static/media/twitter.830c0cc6.svg";